import React from "react";
import svgPaths from "./svgPaths";
import imgMain from "../assets/images/iPhone 17 Pro  mockup.png";
import imgScreen2 from "../assets/images/c54effa44b43b34ed936960da186fc5a5bb1941a.png";
import imgScreen1 from "../assets/images/538389273b46a55bbd3f1664713f8697a963d6cb.png";
import img63122C7C0D09395C8Ecfd791AssetPng from "../assets/images/0c90a2f319dd34defa5ece9a5e7b67c16fe91977.png";
import img63122C774C17C17F583CfacbAssetPng from "../assets/images/a55875682dbb7360b4c1fe8ae6954d248bf94f09.png";

function DuoIPhone17ProSilverMockup() {
  return (
    <div className="relative w-full max-w-sm h-[400px] md:h-[550px] mx-auto lg:absolute lg:h-[755.435px] lg:left-1/2 lg:-translate-x-1/2 lg:top-[524px] lg:w-[744px] lg:mx-0" data-name="Duo iPhone 17 Pro silver mockup">
      {/* Mockup Frame */}
      <div className="absolute inset-0 w-full h-[95%] lg:h-[755.435px]" data-name="main">
        <img alt="" className="absolute inset-0 max-w-none object-contain pointer-events-none size-full" src={imgMain} />
      </div>
      {/* Screen 2 */}
      <div className="absolute h-[78%] left-[47%] top-[16%] w-[50%] lg:h-[613.791px] lg:left-[349.87px] lg:top-[119.33px] lg:w-[371.078px]" data-name="Screen 2">
        <img alt="" className="absolute inset-0 max-w-none object-cover pointer-events-none size-full" src={imgScreen2} />
      </div>
      {/* Screen 1 */}
      <div className="absolute h-[70%] left-[3%] top-[1%] w-[44%] lg:h-[553.85px] lg:left-[24.53px] lg:top-[5.35px] lg:w-[328.29px]" data-name="Screen 1">
        <img alt="" className="absolute inset-0 max-w-none object-cover pointer-events-none size-full" src={imgScreen1} />
      </div>
    </div>
  );
}

function AppDownloadTextWrapper() {
  return (
    <div className="h-auto flex flex-col items-center gap-6 relative w-full lg:w-[800px] lg:absolute lg:left-1/2 lg:-translate-x-1/2 lg:top-[12px]" data-name="div">
      <h2 className="font-['Plus_Jakarta_Sans:ExtraBold',sans-serif] font-extrabold leading-tight text-[#117cf7] text-4xl md:text-[59px] text-center tracking-[-2px]">
        Download the Fixezy App
      </h2>
      <p className="font-['Plus_Jakarta_Sans:SemiBold',sans-serif] font-semibold text-base md:text-xl text-center text-black leading-relaxed max-w-xl">
        Book trusted home services, track your bookings in real time, and manage everything from one simple app—anytime, anywhere.
      </p>
    </div>
  );
}

function AppStoreBadges() {
  return (
    <div className="relative flex gap-4 items-center justify-center w-full mt-4 lg:absolute lg:left-1/2 lg:-translate-x-1/2 lg:top-[315px] lg:mt-0" data-name="div">
      {/* Google Play Store Badge */}
      <div className="bg-[#0f7bf8] relative rounded-[50px] size-[70px] lg:size-[85px] flex items-center justify-center cursor-pointer transition-all hover:scale-105 active:scale-95" data-name="a">
        <div className="overflow-clip relative size-[25px] lg:size-[28px]" data-name="svg">
          <svg className="absolute block inset-0 size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 26.5625 28.3333">
            <g id="Frame">
              <path d={svgPaths.p337b8d00} fill="var(--fill-0, #EA4335)" id="Vector" />
              <path d={svgPaths.p3ebd0700} fill="var(--fill-0, #FBBC04)" id="Vector_2" />
              <path d={svgPaths.p20589400} fill="var(--fill-0, #4285F4)" id="Vector_3" />
              <path d={svgPaths.p31765500} fill="var(--fill-0, #34A853)" id="Vector_4" />
            </g>
          </svg>
        </div>
      </div>
      {/* Apple App Store Badge */}
      <div className="bg-[#0f7bf8] relative rounded-[50px] size-[70px] lg:size-[85px] flex items-center justify-center cursor-pointer transition-all hover:scale-105 active:scale-95" data-name="a">
        <div className="overflow-clip relative size-[38px] lg:size-[42.5px]" data-name="svg">
          <svg className="absolute block inset-0 size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 42.5 42.5">
            <g id="Frame">
              <path d={svgPaths.p20fb4680} fill="var(--fill-0, white)" id="Vector" />
              <path d={svgPaths.p4b29c80} fill="var(--fill-0, white)" id="Vector_2" />
            </g>
          </svg>
        </div>
      </div>
    </div>
  );
}

export default function AppDownload() {
  return (
    <div className="w-full relative overflow-hidden flex flex-col gap-12 pt-12 bg-white lg:h-[1390px] lg:w-[1440px] lg:mx-auto lg:block lg:pt-0">
      {/* Background custom blue gradient */}
      <div className="absolute inset-0 flex h-full items-center justify-center w-full z-0">
        <div className="-scale-y-100 flex-none">
          <div className="h-[1271px] relative w-[1440px]" style={{ backgroundImage: "linear-gradient(to bottom, rgba(196, 224, 254, 0) 0%, rgba(196, 224, 254, 0.5) 15%, rgba(196, 224, 254, 0) 50%)" }} data-name="div.jsx-1198541329" />
        </div>
      </div>

      {/* Decorative cloud shapes */}
      <div className="hidden lg:block absolute inset-[746px_1136px_333px_0] z-10" data-name="63122c7c0d09395c8ecfd791_Asset.png">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <img alt="" className="absolute left-0 max-w-none size-full top-0" src={img63122C7C0D09395C8Ecfd791AssetPng} />
        </div>
      </div>
      <div className="hidden lg:block absolute inset-[800px_0_387px_1128px] z-10" data-name="63122c774c17c17f583cfacb_Asset.png">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <img alt="" className="absolute left-0 max-w-none size-full top-0" src={img63122C774C17C17F583CfacbAssetPng} />
        </div>
      </div>

      <div className="relative z-10 flex flex-col gap-8 w-full max-w-5xl mx-auto items-center lg:block lg:h-[1390px] lg:max-w-none lg:mx-0">
        <AppDownloadTextWrapper />
        <AppStoreBadges />
        <DuoIPhone17ProSilverMockup />
      </div>
    </div>
  );
}
